(function () {
    'use strict';

    angular
        .module('app')
        .factory('campaignCategory', campaignCategory);

    campaignCategory.$inject = ['i18n',];

    function campaignCategory(i18n) {
        var service = {
            get: get,
        };

        var campaignCategory = {
            'family-and-friends': i18n.get('FAMILY_AND_FRIENDS'),
            'influenser-mini': i18n.get('INFLUENSER_MINI'),
            'influenser-insta': i18n.get('INFLUENSER_INSTA'),
            'marketing': i18n.get('MARKETING'),
            'partners': i18n.get('PARTNERS'),
            'physical': i18n.get('PHYSICAL'),
            'staff-benefit': i18n.get('STAFF_BENEFIT'),
            'other': i18n.get('OTHER'),
        };


        return service;


        function get() {
            return campaignCategory;
        }
    }
})();